// Copyright (c) 2022 by Move Closer

import { Module, ModuleContent } from '../../contexts'

import { AvailableModuleDriver } from '../allowed'
import { ResolvedLink, UnresolvedLink } from '../partials'

/**
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
export type NewsletterModule = Module<NewsletterModuleContent, AvailableModuleDriver.Newsletter>

/**
 * @author Michał Rossian <michal.rossian@movecloser.pl> (original)
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (edited)
 */
export interface NewsletterModuleContentData {
  privacyPolicyLink: ResolvedLink | null

  /**
   * Determines the event name for which payload is sent.
   */
  eventName: string
}

export type NewsletterModuleContent = ModuleContent

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface NewsletterModuleContentInput extends Omit<NewsletterModuleContentData, 'privacyPolicyLink'> {
  privacyPolicyLink: UnresolvedLink
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export enum NewsletterFormState {
  Error = 'error',
  Success = 'success'
}
